export const form = {
  formCopyLink: 'Copiar link',
  formLinkCopied: 'Link copiado!'
}
